module.exports = __webpack_public_path__ + "img/all-sony-product-except-xperia.d9d71c95.png";